import http from "../http"

export function insectUserLogin(username, password) {
  return http({
    url: '/api/queryKey?username=' + username + '&password=' + password,
    method: 'get',
    urlType: 'insectPest'
  })
}

export function insectDevice(token) {
  return http({
    url: '/api/queryDevStatus?appName=Insects&token=' + token,
    method: 'get',
    urlType: 'insectPest'
  })
}

export function insectAnalyse(startTime, endTime, imei, token) {
  return http({
    url: '/api/queryInsectImagesByTimeRange?stime=' + startTime + '&etime=' + endTime + '&imei='+ imei + '&appName=Insects&token=' + token,
    method: 'get',
    urlType: 'insectPest'
  })
}

export function insectStatistic(startTime, endTime, imei, token) {
  return http({
    url: '/api/insectStatistic?stime=' + startTime +'&etime=' + endTime + '&imei='+ imei +'&appName=Insects&token=' + token,
    method: 'get',
    urlType: 'insectPest'
  })
}



// WEBPACK FOOTER //
// ./src/until/api/inesctPest.js